/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiIntegrationsDtoConnectIntegrationDto,
  WebApiIntegrationsDtoCreateAgreementDto,
  WebApiIntegrationsDtoCreateMultiplePaymentLinkDto,
  WebApiIntegrationsDtoCreatePaymentLinkDto,
  WebApiIntegrationsDtoExternalPaymentRefundDto,
  WebApiIntegrationsDtoIntegrationDto,
  WebApiIntegrationsDtoIntegrationSyncConfigDto,
  WebApiIntegrationsDtoMemberSyncReportDto,
  WebApiIntegrationsDtoMemberSyncResultDto,
  WebApiIntegrationsDtoPaymentLinkCallbackDto,
  WebApiIntegrationsDtoPingPaymentPaymentReportDto,
  WebApiIntegrationsDtoRefundPaymentLinkDto,
  WebApiIntegrationsDtoRefundStatusCallbackDto,
  WebApiIntegrationsObjectsIntegrationType,
  WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse,
  WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse,
} from '../models';
import {
    WebApiIntegrationsDtoConnectIntegrationDtoFromJSON,
    WebApiIntegrationsDtoConnectIntegrationDtoToJSON,
    WebApiIntegrationsDtoCreateAgreementDtoFromJSON,
    WebApiIntegrationsDtoCreateAgreementDtoToJSON,
    WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoFromJSON,
    WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoToJSON,
    WebApiIntegrationsDtoCreatePaymentLinkDtoFromJSON,
    WebApiIntegrationsDtoCreatePaymentLinkDtoToJSON,
    WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSON,
    WebApiIntegrationsDtoExternalPaymentRefundDtoToJSON,
    WebApiIntegrationsDtoIntegrationDtoFromJSON,
    WebApiIntegrationsDtoIntegrationDtoToJSON,
    WebApiIntegrationsDtoIntegrationSyncConfigDtoFromJSON,
    WebApiIntegrationsDtoIntegrationSyncConfigDtoToJSON,
    WebApiIntegrationsDtoMemberSyncReportDtoFromJSON,
    WebApiIntegrationsDtoMemberSyncReportDtoToJSON,
    WebApiIntegrationsDtoMemberSyncResultDtoFromJSON,
    WebApiIntegrationsDtoMemberSyncResultDtoToJSON,
    WebApiIntegrationsDtoPaymentLinkCallbackDtoFromJSON,
    WebApiIntegrationsDtoPaymentLinkCallbackDtoToJSON,
    WebApiIntegrationsDtoPingPaymentPaymentReportDtoFromJSON,
    WebApiIntegrationsDtoPingPaymentPaymentReportDtoToJSON,
    WebApiIntegrationsDtoRefundPaymentLinkDtoFromJSON,
    WebApiIntegrationsDtoRefundPaymentLinkDtoToJSON,
    WebApiIntegrationsDtoRefundStatusCallbackDtoFromJSON,
    WebApiIntegrationsDtoRefundStatusCallbackDtoToJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseToJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseFromJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseToJSON,
} from '../models';

export interface ApiIntegrationCancelPaymentLinkDeleteRequest {
    paymentUrl?: string;
}

export interface ApiIntegrationCheckFortnoxCustomerGetRequest {
    customerNumber?: string;
}

export interface ApiIntegrationCheckSpirisCustomerGetRequest {
    customerNumber?: string;
}

export interface ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest {
    webApiIntegrationsDtoCreateAgreementDto?: WebApiIntegrationsDtoCreateAgreementDto;
}

export interface ApiIntegrationCreateInvoiceFromPaymentLinkPutRequest {
    paymentLinkId?: string;
}

export interface ApiIntegrationCreateMemberInFortnoxPostRequest {
    memberId?: number;
}

export interface ApiIntegrationCreateMemberInIntegrationPostRequest {
    memberId?: number;
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationCreateMultiplePaymentLinksPostRequest {
    webApiIntegrationsDtoCreateMultiplePaymentLinkDto?: WebApiIntegrationsDtoCreateMultiplePaymentLinkDto;
}

export interface ApiIntegrationCreatePaymentLinkPostRequest {
    webApiIntegrationsDtoCreatePaymentLinkDto?: WebApiIntegrationsDtoCreatePaymentLinkDto;
}

export interface ApiIntegrationDeleteRequest {
    integrationId?: number;
}

export interface ApiIntegrationDownloadInvoiceFromPaymentLinkGetRequest {
    paymentLinkId?: string;
}

export interface ApiIntegrationGetRequest {
    type?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationGetAllocationsGetRequest {
    fromDate?: Date;
    toDate?: Date;
}

export interface ApiIntegrationGetAllocationsPdfGetRequest {
    fromDate?: Date;
    toDate?: Date;
}

export interface ApiIntegrationGetIntegrationSyncConfigGetRequest {
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationGetInvoiceFromPaymentLinkGetRequest {
    paymentLinkId?: string;
}

export interface ApiIntegrationGetInvoicePdfGetRequest {
    type?: WebApiIntegrationsObjectsIntegrationType;
    invoiceNumber?: string;
}

export interface ApiIntegrationGetInvoicesGetRequest {
    type?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationGetMemberSyncReportGetRequest {
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationGetReceiptFromPaymentLinkGetRequest {
    paymentLinkId?: string;
}

export interface ApiIntegrationGetRefundsByMemberGetRequest {
    memberId?: number;
}

export interface ApiIntegrationHandlePaymentLinkCallbackPostRequest {
    webApiIntegrationsDtoPaymentLinkCallbackDto?: WebApiIntegrationsDtoPaymentLinkCallbackDto;
}

export interface ApiIntegrationHandleRefundStatusUpdatedPostRequest {
    webApiIntegrationsDtoRefundStatusCallbackDto?: WebApiIntegrationsDtoRefundStatusCallbackDto;
}

export interface ApiIntegrationLinkMemberToFortnoxPostRequest {
    memberId?: number;
}

export interface ApiIntegrationLinkMemberToIntegrationPostRequest {
    memberId?: number;
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationPostRequest {
    webApiIntegrationsDtoConnectIntegrationDto?: WebApiIntegrationsDtoConnectIntegrationDto;
}

export interface ApiIntegrationRefundPaymentLinkPostRequest {
    webApiIntegrationsDtoRefundPaymentLinkDto?: WebApiIntegrationsDtoRefundPaymentLinkDto;
}

export interface ApiIntegrationSettlePaymentOrderPostRequest {
    body?: string;
}

export interface ApiIntegrationSyncFortNoxDataPostRequest {
    body?: number;
}

export interface ApiIntegrationSyncMembersToIntegrationPostRequest {
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
}

export interface ApiIntegrationSyncSpirisDataPostRequest {
    body?: number;
}

export interface ApiIntegrationUpdateFortnoxSyncConfigPutRequest {
    webApiIntegrationsDtoIntegrationSyncConfigDto?: WebApiIntegrationsDtoIntegrationSyncConfigDto;
}

export interface ApiIntegrationUpdateIntegrationSyncConfigPutRequest {
    webApiIntegrationsDtoIntegrationSyncConfigDto?: WebApiIntegrationsDtoIntegrationSyncConfigDto;
}

/**
 * 
 */
export class IntegrationApi extends runtime.BaseAPI {

    /**
     * 
     */
    async apiIntegrationCancelPaymentLinkDeleteRaw(requestParameters: ApiIntegrationCancelPaymentLinkDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.paymentUrl !== undefined) {
            queryParameters['paymentUrl'] = requestParameters.paymentUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CancelPaymentLink`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiIntegrationCancelPaymentLinkDelete(requestParameters: ApiIntegrationCancelPaymentLinkDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiIntegrationCancelPaymentLinkDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if a CustomerNumber already exists in Fortnox. Returns the customer name or null.
     */
    async apiIntegrationCheckFortnoxCustomerGetRaw(requestParameters: ApiIntegrationCheckFortnoxCustomerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.customerNumber !== undefined) {
            queryParameters['customerNumber'] = requestParameters.customerNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CheckFortnoxCustomer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Checks if a CustomerNumber already exists in Fortnox. Returns the customer name or null.
     */
    async apiIntegrationCheckFortnoxCustomerGet(requestParameters: ApiIntegrationCheckFortnoxCustomerGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiIntegrationCheckFortnoxCustomerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if a CustomerNumber already exists in Spiris. Returns the customer name or null.
     */
    async apiIntegrationCheckSpirisCustomerGetRaw(requestParameters: ApiIntegrationCheckSpirisCustomerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.customerNumber !== undefined) {
            queryParameters['customerNumber'] = requestParameters.customerNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CheckSpirisCustomer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Checks if a CustomerNumber already exists in Spiris. Returns the customer name or null.
     */
    async apiIntegrationCheckSpirisCustomerGet(requestParameters: ApiIntegrationCheckSpirisCustomerGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiIntegrationCheckSpirisCustomerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationCreateAndPublishPingPaymentAgreementPostRaw(requestParameters: ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateAndPublishPingPaymentAgreement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoCreateAgreementDtoToJSON(requestParameters.webApiIntegrationsDtoCreateAgreementDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiIntegrationCreateAndPublishPingPaymentAgreementPost(requestParameters: ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiIntegrationCreateAndPublishPingPaymentAgreementPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create invoice from a completed payment link
     */
    async apiIntegrationCreateInvoiceFromPaymentLinkPutRaw(requestParameters: ApiIntegrationCreateInvoiceFromPaymentLinkPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse>> {
        const queryParameters: any = {};

        if (requestParameters.paymentLinkId !== undefined) {
            queryParameters['paymentLinkId'] = requestParameters.paymentLinkId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateInvoiceFromPaymentLink`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Create invoice from a completed payment link
     */
    async apiIntegrationCreateInvoiceFromPaymentLinkPut(requestParameters: ApiIntegrationCreateInvoiceFromPaymentLinkPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse> {
        const response = await this.apiIntegrationCreateInvoiceFromPaymentLinkPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fortnox-specific: create member. Use CreateMemberInIntegration for new code.
     */
    async apiIntegrationCreateMemberInFortnoxPostRaw(requestParameters: ApiIntegrationCreateMemberInFortnoxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateMemberInFortnox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Fortnox-specific: create member. Use CreateMemberInIntegration for new code.
     */
    async apiIntegrationCreateMemberInFortnoxPost(requestParameters: ApiIntegrationCreateMemberInFortnoxPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiIntegrationCreateMemberInFortnoxPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a member as a customer in the given integration.
     */
    async apiIntegrationCreateMemberInIntegrationPostRaw(requestParameters: ApiIntegrationCreateMemberInIntegrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        if (requestParameters.integrationType !== undefined) {
            queryParameters['integrationType'] = requestParameters.integrationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateMemberInIntegration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Creates a member as a customer in the given integration.
     */
    async apiIntegrationCreateMemberInIntegrationPost(requestParameters: ApiIntegrationCreateMemberInIntegrationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiIntegrationCreateMemberInIntegrationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreateMultiplePaymentLinksPostRaw(requestParameters: ApiIntegrationCreateMultiplePaymentLinksPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreateMultiplePaymentLinks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoToJSON(requestParameters.webApiIntegrationsDtoCreateMultiplePaymentLinkDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreateMultiplePaymentLinksPost(requestParameters: ApiIntegrationCreateMultiplePaymentLinksPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiIntegrationCreateMultiplePaymentLinksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreatePaymentLinkPostRaw(requestParameters: ApiIntegrationCreatePaymentLinkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/CreatePaymentLink`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoCreatePaymentLinkDtoToJSON(requestParameters.webApiIntegrationsDtoCreatePaymentLinkDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationCreatePaymentLinkPost(requestParameters: ApiIntegrationCreatePaymentLinkPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse> {
        const response = await this.apiIntegrationCreatePaymentLinkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationDeleteRaw(requestParameters: ApiIntegrationDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.integrationId !== undefined) {
            queryParameters['integrationId'] = requestParameters.integrationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get integration by type
     */
    async apiIntegrationDelete(requestParameters: ApiIntegrationDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiIntegrationDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download invoice PDF file from payment link
     */
    async apiIntegrationDownloadInvoiceFromPaymentLinkGetRaw(requestParameters: ApiIntegrationDownloadInvoiceFromPaymentLinkGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.paymentLinkId !== undefined) {
            queryParameters['paymentLinkId'] = requestParameters.paymentLinkId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/DownloadInvoiceFromPaymentLink`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download invoice PDF file from payment link
     */
    async apiIntegrationDownloadInvoiceFromPaymentLinkGet(requestParameters: ApiIntegrationDownloadInvoiceFromPaymentLinkGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationDownloadInvoiceFromPaymentLinkGetRaw(requestParameters, initOverrides);
    }

    /**
     * Get integration by type
     */
    async apiIntegrationGetRaw(requestParameters: ApiIntegrationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoIntegrationDto>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoIntegrationDtoFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationGet(requestParameters: ApiIntegrationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoIntegrationDto> {
        const response = await this.apiIntegrationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationGetActiveIntegrationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiIntegrationsDtoIntegrationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetActiveIntegrations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiIntegrationsDtoIntegrationDtoFromJSON));
    }

    /**
     * 
     */
    async apiIntegrationGetActiveIntegrationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiIntegrationsDtoIntegrationDto>> {
        const response = await this.apiIntegrationGetActiveIntegrationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiIntegrationGetAllocationsGetRaw(requestParameters: ApiIntegrationGetAllocationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoPingPaymentPaymentReportDto>> {
        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = (requestParameters.fromDate as any).toISOString();
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = (requestParameters.toDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetAllocations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoPingPaymentPaymentReportDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiIntegrationGetAllocationsGet(requestParameters: ApiIntegrationGetAllocationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoPingPaymentPaymentReportDto> {
        const response = await this.apiIntegrationGetAllocationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiIntegrationGetAllocationsPdfGetRaw(requestParameters: ApiIntegrationGetAllocationsPdfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = (requestParameters.fromDate as any).toISOString();
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = (requestParameters.toDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetAllocationsPdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiIntegrationGetAllocationsPdfGet(requestParameters: ApiIntegrationGetAllocationsPdfGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationGetAllocationsPdfGetRaw(requestParameters, initOverrides);
    }

    /**
     * Fortnox-specific: get sync config. Use GetIntegrationSyncConfig for new code.
     */
    async apiIntegrationGetFortnoxSyncConfigGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoIntegrationSyncConfigDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetFortnoxSyncConfig`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoIntegrationSyncConfigDtoFromJSON(jsonValue));
    }

    /**
     * Fortnox-specific: get sync config. Use GetIntegrationSyncConfig for new code.
     */
    async apiIntegrationGetFortnoxSyncConfigGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoIntegrationSyncConfigDto> {
        const response = await this.apiIntegrationGetFortnoxSyncConfigGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get sync configuration for an integration.
     */
    async apiIntegrationGetIntegrationSyncConfigGetRaw(requestParameters: ApiIntegrationGetIntegrationSyncConfigGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoIntegrationSyncConfigDto>> {
        const queryParameters: any = {};

        if (requestParameters.integrationType !== undefined) {
            queryParameters['integrationType'] = requestParameters.integrationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetIntegrationSyncConfig`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoIntegrationSyncConfigDtoFromJSON(jsonValue));
    }

    /**
     * Get sync configuration for an integration.
     */
    async apiIntegrationGetIntegrationSyncConfigGet(requestParameters: ApiIntegrationGetIntegrationSyncConfigGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoIntegrationSyncConfigDto> {
        const response = await this.apiIntegrationGetIntegrationSyncConfigGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get invoice for a payment link
     */
    async apiIntegrationGetInvoiceFromPaymentLinkGetRaw(requestParameters: ApiIntegrationGetInvoiceFromPaymentLinkGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse>> {
        const queryParameters: any = {};

        if (requestParameters.paymentLinkId !== undefined) {
            queryParameters['paymentLinkId'] = requestParameters.paymentLinkId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetInvoiceFromPaymentLink`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get invoice for a payment link
     */
    async apiIntegrationGetInvoiceFromPaymentLinkGet(requestParameters: ApiIntegrationGetInvoiceFromPaymentLinkGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkGetInvoiceFromPaymentLinkResponse> {
        const response = await this.apiIntegrationGetInvoiceFromPaymentLinkGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get invoice PDF from integration provider
     */
    async apiIntegrationGetInvoicePdfGetRaw(requestParameters: ApiIntegrationGetInvoicePdfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.invoiceNumber !== undefined) {
            queryParameters['invoiceNumber'] = requestParameters.invoiceNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetInvoicePdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get invoice PDF from integration provider
     */
    async apiIntegrationGetInvoicePdfGet(requestParameters: ApiIntegrationGetInvoicePdfGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationGetInvoicePdfGetRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async apiIntegrationGetInvoicesGetRaw(requestParameters: ApiIntegrationGetInvoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetInvoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async apiIntegrationGetInvoicesGet(requestParameters: ApiIntegrationGetInvoicesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiIntegrationGetInvoicesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get member sync report for current company and integration type.
     */
    async apiIntegrationGetMemberSyncReportGetRaw(requestParameters: ApiIntegrationGetMemberSyncReportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoMemberSyncReportDto>> {
        const queryParameters: any = {};

        if (requestParameters.integrationType !== undefined) {
            queryParameters['integrationType'] = requestParameters.integrationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetMemberSyncReport`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoMemberSyncReportDtoFromJSON(jsonValue));
    }

    /**
     * Get member sync report for current company and integration type.
     */
    async apiIntegrationGetMemberSyncReportGet(requestParameters: ApiIntegrationGetMemberSyncReportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoMemberSyncReportDto> {
        const response = await this.apiIntegrationGetMemberSyncReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get receipt for a payment link
     */
    async apiIntegrationGetReceiptFromPaymentLinkGetRaw(requestParameters: ApiIntegrationGetReceiptFromPaymentLinkGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.paymentLinkId !== undefined) {
            queryParameters['paymentLinkId'] = requestParameters.paymentLinkId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetReceiptFromPaymentLink`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get receipt for a payment link
     */
    async apiIntegrationGetReceiptFromPaymentLinkGet(requestParameters: ApiIntegrationGetReceiptFromPaymentLinkGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationGetReceiptFromPaymentLinkGetRaw(requestParameters, initOverrides);
    }

    /**
     * Get all refunds for a specific member in the current company
     */
    async apiIntegrationGetRefundsByMemberGetRaw(requestParameters: ApiIntegrationGetRefundsByMemberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiIntegrationsDtoExternalPaymentRefundDto>>> {
        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetRefundsByMember`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSON));
    }

    /**
     * Get all refunds for a specific member in the current company
     */
    async apiIntegrationGetRefundsByMemberGet(requestParameters: ApiIntegrationGetRefundsByMemberGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiIntegrationsDtoExternalPaymentRefundDto>> {
        const response = await this.apiIntegrationGetRefundsByMemberGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all refunds for the current company
     */
    async apiIntegrationGetRefundsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiIntegrationsDtoExternalPaymentRefundDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/GetRefunds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSON));
    }

    /**
     * Get all refunds for the current company
     */
    async apiIntegrationGetRefundsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiIntegrationsDtoExternalPaymentRefundDto>> {
        const response = await this.apiIntegrationGetRefundsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get integration by type
     */
    async apiIntegrationHandlePaymentLinkCallbackPostRaw(requestParameters: ApiIntegrationHandlePaymentLinkCallbackPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/HandlePaymentLinkCallback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoPaymentLinkCallbackDtoToJSON(requestParameters.webApiIntegrationsDtoPaymentLinkCallbackDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON(jsonValue));
    }

    /**
     * Get integration by type
     */
    async apiIntegrationHandlePaymentLinkCallbackPost(requestParameters: ApiIntegrationHandlePaymentLinkCallbackPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse> {
        const response = await this.apiIntegrationHandlePaymentLinkCallbackPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Callback endpoint for Ping Payments refund status updates.  Configured at tenant level via the UpdateTenant endpoint.
     */
    async apiIntegrationHandleRefundStatusUpdatedPostRaw(requestParameters: ApiIntegrationHandleRefundStatusUpdatedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/HandleRefundStatusUpdated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoRefundStatusCallbackDtoToJSON(requestParameters.webApiIntegrationsDtoRefundStatusCallbackDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Callback endpoint for Ping Payments refund status updates.  Configured at tenant level via the UpdateTenant endpoint.
     */
    async apiIntegrationHandleRefundStatusUpdatedPost(requestParameters: ApiIntegrationHandleRefundStatusUpdatedPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationHandleRefundStatusUpdatedPostRaw(requestParameters, initOverrides);
    }

    /**
     * Fortnox-specific: link to existing customer. Use LinkMemberToIntegration for new code.
     */
    async apiIntegrationLinkMemberToFortnoxPostRaw(requestParameters: ApiIntegrationLinkMemberToFortnoxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/LinkMemberToFortnox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Fortnox-specific: link to existing customer. Use LinkMemberToIntegration for new code.
     */
    async apiIntegrationLinkMemberToFortnoxPost(requestParameters: ApiIntegrationLinkMemberToFortnoxPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationLinkMemberToFortnoxPostRaw(requestParameters, initOverrides);
    }

    /**
     * Links a member to an already-existing customer in the given integration.
     */
    async apiIntegrationLinkMemberToIntegrationPostRaw(requestParameters: ApiIntegrationLinkMemberToIntegrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        if (requestParameters.integrationType !== undefined) {
            queryParameters['integrationType'] = requestParameters.integrationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/LinkMemberToIntegration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Links a member to an already-existing customer in the given integration.
     */
    async apiIntegrationLinkMemberToIntegrationPost(requestParameters: ApiIntegrationLinkMemberToIntegrationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationLinkMemberToIntegrationPostRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async apiIntegrationPostRaw(requestParameters: ApiIntegrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoIntegrationDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoConnectIntegrationDtoToJSON(requestParameters.webApiIntegrationsDtoConnectIntegrationDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoIntegrationDtoFromJSON(jsonValue));
    }

    /**
     * 
     */
    async apiIntegrationPost(requestParameters: ApiIntegrationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoIntegrationDto> {
        const response = await this.apiIntegrationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refund a completed payment link
     */
    async apiIntegrationRefundPaymentLinkPostRaw(requestParameters: ApiIntegrationRefundPaymentLinkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoExternalPaymentRefundDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/RefundPaymentLink`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoRefundPaymentLinkDtoToJSON(requestParameters.webApiIntegrationsDtoRefundPaymentLinkDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSON(jsonValue));
    }

    /**
     * Refund a completed payment link
     */
    async apiIntegrationRefundPaymentLinkPost(requestParameters: ApiIntegrationRefundPaymentLinkPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoExternalPaymentRefundDto> {
        const response = await this.apiIntegrationRefundPaymentLinkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiIntegrationSettlePaymentOrderPostRaw(requestParameters: ApiIntegrationSettlePaymentOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SettlePaymentOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiIntegrationSettlePaymentOrderPost(requestParameters: ApiIntegrationSettlePaymentOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationSettlePaymentOrderPostRaw(requestParameters, initOverrides);
    }

    /**
     * Triggered from the UI — companyId comes from the JWT token.
     */
    async apiIntegrationSyncFortNoxDataForCurrentCompanyPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncFortNoxDataForCurrentCompany`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggered from the UI — companyId comes from the JWT token.
     */
    async apiIntegrationSyncFortNoxDataForCurrentCompanyPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationSyncFortNoxDataForCurrentCompanyPostRaw(initOverrides);
    }

    /**
     * Triggered by the scheduled job — companyId comes from the request body.
     */
    async apiIntegrationSyncFortNoxDataPostRaw(requestParameters: ApiIntegrationSyncFortNoxDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncFortNoxData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggered by the scheduled job — companyId comes from the request body.
     */
    async apiIntegrationSyncFortNoxDataPost(requestParameters: ApiIntegrationSyncFortNoxDataPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationSyncFortNoxDataPostRaw(requestParameters, initOverrides);
    }

    /**
     * Fortnox-specific: push changes for linked members. Use SyncMembersToIntegration for new code.
     */
    async apiIntegrationSyncMembersToFortnoxPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoMemberSyncResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncMembersToFortnox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoMemberSyncResultDtoFromJSON(jsonValue));
    }

    /**
     * Fortnox-specific: push changes for linked members. Use SyncMembersToIntegration for new code.
     */
    async apiIntegrationSyncMembersToFortnoxPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoMemberSyncResultDto> {
        const response = await this.apiIntegrationSyncMembersToFortnoxPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Push data/status changes for linked members to any integration.
     */
    async apiIntegrationSyncMembersToIntegrationPostRaw(requestParameters: ApiIntegrationSyncMembersToIntegrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoMemberSyncResultDto>> {
        const queryParameters: any = {};

        if (requestParameters.integrationType !== undefined) {
            queryParameters['integrationType'] = requestParameters.integrationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncMembersToIntegration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoMemberSyncResultDtoFromJSON(jsonValue));
    }

    /**
     * Push data/status changes for linked members to any integration.
     */
    async apiIntegrationSyncMembersToIntegrationPost(requestParameters: ApiIntegrationSyncMembersToIntegrationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoMemberSyncResultDto> {
        const response = await this.apiIntegrationSyncMembersToIntegrationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Triggered from the UI — companyId comes from the JWT token.
     */
    async apiIntegrationSyncSpirisDataForCurrentCompanyPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncSpirisDataForCurrentCompany`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggered from the UI — companyId comes from the JWT token.
     */
    async apiIntegrationSyncSpirisDataForCurrentCompanyPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationSyncSpirisDataForCurrentCompanyPostRaw(initOverrides);
    }

    /**
     * Triggered by the scheduled job — companyId comes from the request body.
     */
    async apiIntegrationSyncSpirisDataPostRaw(requestParameters: ApiIntegrationSyncSpirisDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/SyncSpirisData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggered by the scheduled job — companyId comes from the request body.
     */
    async apiIntegrationSyncSpirisDataPost(requestParameters: ApiIntegrationSyncSpirisDataPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationSyncSpirisDataPostRaw(requestParameters, initOverrides);
    }

    /**
     * Fortnox-specific: update sync config. Use UpdateIntegrationSyncConfig for new code.
     */
    async apiIntegrationUpdateFortnoxSyncConfigPutRaw(requestParameters: ApiIntegrationUpdateFortnoxSyncConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/UpdateFortnoxSyncConfig`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoIntegrationSyncConfigDtoToJSON(requestParameters.webApiIntegrationsDtoIntegrationSyncConfigDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Fortnox-specific: update sync config. Use UpdateIntegrationSyncConfig for new code.
     */
    async apiIntegrationUpdateFortnoxSyncConfigPut(requestParameters: ApiIntegrationUpdateFortnoxSyncConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationUpdateFortnoxSyncConfigPutRaw(requestParameters, initOverrides);
    }

    /**
     * Update sync configuration for an integration (IntegrationType is in the body).
     */
    async apiIntegrationUpdateIntegrationSyncConfigPutRaw(requestParameters: ApiIntegrationUpdateIntegrationSyncConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Integration/UpdateIntegrationSyncConfig`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiIntegrationsDtoIntegrationSyncConfigDtoToJSON(requestParameters.webApiIntegrationsDtoIntegrationSyncConfigDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update sync configuration for an integration (IntegrationType is in the body).
     */
    async apiIntegrationUpdateIntegrationSyncConfigPut(requestParameters: ApiIntegrationUpdateIntegrationSyncConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiIntegrationUpdateIntegrationSyncConfigPutRaw(requestParameters, initOverrides);
    }

}
